import React from 'react';

import { Content } from './Content.js';

export default class ParagraphWithoutAnchor extends React.Component {

  render() {
    return (
      <p>
        {Content[this.props.page].body2}
      </p>
    );
  }

};
